import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ErrorLog } from '../models/ErrorLog';
import { EndPointService } from './end-point.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorLogService {

  private _baseUrl = '/api/error/';
  private _logClientError = 'log';

  public constructor(private _endPointService: EndPointService) {
    this._endPointService.registerEndPoint(
      'error_log_client',
      `${this._baseUrl}${this._logClientError}`,
      false
    );
  }

  public LogClientError(errorLog: ErrorLog): Observable<void> {
    return this._endPointService.call<void>('error_log_client', errorLog);
  }
}
